import React, { useEffect, useState } from 'react';
import Header from "../../BusinessHeaderAfterLogin";
import Footer from "../../BusinessFooterAfterLogin";
import BusinessSidebar from "../../BusinessSidebar";
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { Link,useParams } from 'react-router-dom';
import Image from 'react-bootstrap/Image';
import moment from "moment";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './BusinessDealDetail.css';
import API from '../../../Utils/Api';
import loader from '../../../assests/loader.gif';
import { gettoastwarning, gettoastsuccess } from '../../../Utils/Common';
import Modal from 'react-bootstrap/Modal';


const BusinessDealDetail = () => {
    const { id } = useParams();
    const [loading, setLoading] = useState(true);
     const [inputs, setInputs] = useState({
        deal_id: '', business_id: '',deal_unique_id:'', total_reviews: 0, beat_online_price: 'no', deal_end_date: '', listing_title: '', description: '', home_delivery: 0, online_price: '', online_link: '', deal_master_type: '', deal_type: '', amount: 0, discount: 0, original_mrp: '', business_name: '', address: '', business_contact_number: '', sale_price: '', buy_qty: '', get_qty: '', store_percent_discount: '', store_cash_discount: '', category_name: '', subcategory_name: '', is_deal_clipped: false, is_liked: false, is_dis_liked: false, total_like: 0, total_dis_like: 0,slug:'',admin_approve:0
    });

    const [images, setImages] = useState([]);

    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const [isSidebarVisible, setIsSidebarVisible] = useState(false);

    const toggleSidebar = () => {
        setIsSidebarVisible((prev) => !prev);
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: true,
    };

    const [isActive, setIsActive] = useState(true);

    useEffect(() => {
        document.title = `Business Deal Detail | Local Bells`;
        document.getElementById('bodywrap').className = 'businoti overflow-hidden';

        let formData = new FormData();
        formData.append(`deal_id`, id);
        formData.append(`business_id`, localStorage.getItem("business_id"));
        API.post('get_deal_detail', formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {

                } else {

                    var beat_online_price = 'no';
                    if (response.data.data.deal_master_type === 'specific') {
                        beat_online_price = response.data.data.beat_online_price;
                    }
                    var home_delivery = 0;
                    if (response.data.data.deal_master_type === 'specific') {
                        home_delivery = response.data.data.home_delivery;
                    }

                    setInputs(
                        {
                            deal_id: response.data.data.deal_id,
                            business_id: response.data.data.business_id,
                            deal_unique_id:response.data.data.deal_unique_id,
                            total_reviews: response.data.data.total_reviews,
                            beat_online_price: beat_online_price,
                            deal_end_date: response.data.data.deal_end_date,
                            listing_title: response.data.data.listing_title,
                            description: response.data.data.description,
                            home_delivery: home_delivery,
                            online_price: response.data.data.online_price,
                            online_link: response.data.data.online_link,
                            deal_master_type: response.data.data.deal_master_type,
                            deal_type: response.data.data.deal_type,
                            amount: response.data.data.amount,
                            discount: response.data.data.discount,
                            original_mrp: response.data.data.original_mrp,
                            business_name: response.data.data.business_name,
                            address: response.data.data.address,
                            business_contact_number: response.data.data.business_contact_number,
                            sale_price: response.data.data.sale_price,
                            buy_qty: response.data.data.buy_qty,
                            get_qty: response.data.data.get_qty,
                            store_percent_discount: response.data.data.store_percent_discount,
                            store_cash_discount: response.data.data.store_cash_discount,
                            category_name: response.data.data.category_name,
                            subcategory_name: response.data.data.subcategory_name,
                            is_deal_clipped: response.data.data.is_deal_clipped,
                            is_liked: response.data.data.is_liked,
                            is_dis_liked: response.data.data.is_dis_liked,
                            total_like: response.data.data.total_like,
                            total_dis_like: response.data.data.total_dis_like,
                            slug:response.data.data.slug,
                            admin_approve:response.data.data.admin_approve,
                        });
                        setImages(response.data.data.deal_images);
                        if (response.data.data.status) {
                            setIsActive(true);
                        }else{
                            setIsActive(false);
                        }
                }
            }).catch(error => {
                setLoading(false);
            });


    }, [id]);


const delete_modal_deal = () => {
        
        setShow(true);
    }
const delete_deal = () => {
        setLoading(true);
        setShow(false);
        let formData = new FormData();
        formData.append(`business_id`, localStorage.getItem("business_id"));
        formData.append(`deal_id`, id);
        API.post('delete_deal', formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {
                    gettoastwarning(response.data.message, '');
                } else {
                    gettoastsuccess(response.data.message, '/business/my-deal');

                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });
    }

    const handleStatus = (e) => {
        const isChecked = e.target.checked;
        var status = 0;
        if (isChecked) {
            status = 1;
            setIsActive(true);
        }else{
            setIsActive(false);
        }
        
        setLoading(true);
        let formData = new FormData();
        formData.append(`business_id`, localStorage.getItem("business_id"));
        formData.append(`deal_id`, id);
        formData.append(`type`, 'active_status');
        formData.append(`status`, status);
        API.post('update_status_deal', formData)
            .then(response => {
                setLoading(false);
                if (response.data.status === false) {
                    gettoastwarning(response.data.message, '');
                } else {
                    gettoastsuccess(response.data.message, '');
                }
            }).catch(error => {
                setLoading(false);
                gettoastwarning("Something went wrong. Please try again later.", '');
            });
    }

    return (
        <>
            <section className="main-cont-box">
                <Container>
                    <Row>
                        <BusinessSidebar isVisible={isSidebarVisible} setIsVisible={setIsSidebarVisible} />
                        <Col md={12} lg={9} xl={9} xxl={10} className='main-cont-box-right'>
                            <Header toggleSidebar={toggleSidebar} />

                            <div className='nei-cont'>
                                <Row className="justify-content-center">
                                    <Col lg={8} xl={8}>
                                        <div className='white-box '>

                                            <Row>
                                                <div className="d-flex align-items-start justify-content-between gap-3">
                                                    <div className="dd-tag">
                                                        <Link to="">{inputs.category_name}</Link>
                                                        {inputs.subcategory_name && (
                                                        <>
                                                            <p> <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/right-arrow.webp'} className="img-fluid" alt="right-arrow" /> </p>
                                                            <Link to="">{inputs.subcategory_name}</Link>
                                                        </>
                                                        )}
                                                    </div>
                                                </div>
                                            </Row>
                                            {images.length > 0 && (
                                            <>
                                            <Row className='new-slider-deal'>
                                                {images.length === 1 ? (
                                                    <Image
                                                        src={images[0].image}
                                                        className="img-fluid w-100"
                                                        alt="ad-banner"
                                                    />
                                                )  : (
                                                    <Slider {...settings} className="slider-deal-add">
                                                        {images.map((val1, index1) => {
                                                        return (<>
                                                        <div>
                                                            <div className="position-relative">
                                                                <Image
                                                                    src={val1.image}
                                                                    className="img-fluid"
                                                                    alt="ad-banner"
                                                                />
                                                                <div className="d-id position-absolute">
                                                                    Deal ID: #{inputs.deal_unique_id}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        </>
                                                        );
                                                      })}
                                                    </Slider>
                                                )}
                                            </Row>
                                            </>
                                                )}
                                            <Row>
                                                <Col xs={12} sm className='dd-cont-left mt-4'>

                                                    <h2>{inputs.listing_title}</h2>
                                                    {(() => {
                                                        if (inputs.deal_master_type === 'specific') {
                                                            if (inputs.deal_type === 1) {
                                                                return (<div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'><strike className="me-2"><h5>Rs. {inputs.original_mrp}</h5></strike><h5>Rs. {inputs.sale_price}</h5></div>
                                                                    <h6 class="peroff">{inputs.discount}% off</h6>
                                                                </div>)
                                                            } else if (inputs.deal_type === 2) {
                                                                return (<div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'><h5>Buy {inputs.buy_qty} Get {inputs.get_qty}</h5></div>
                                                                </div>)
                                                            }
                                                        } else if (inputs.deal_master_type === 'general') {
                                                            if (inputs.deal_type === 3) {
                                                                return (<div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'><h5>{inputs.store_percent_discount}% OFF</h5></div>
                                                                </div>)
                                                            } else if (inputs.deal_type === 4) {
                                                                return (<div className='d-flex align-center csb-title'>
                                                                    <div className='d-flex'><h5>{inputs.store_cash_discount} OFF</h5></div>
                                                                </div>)
                                                            }
                                                        } else if (inputs.deal_master_type === 'free') {
                                                            return (<div className='d-flex align-center csb-title'>
                                                                <div className='d-flex'><h5 className="text-danger">FREE Shaving</h5></div>
                                                            </div>)
                                                        }
                                                    })()}
                                                    {/*<div className='d-flex align-center csb-title mt-3'>
                                                        <div className='d-flex'><strike className="me-2"><h5>Rs.5415 </h5></strike><h5>Rs. 8541</h5></div>
                                                        <h6 className="peroff">% off</h6>
                                                    </div>*/}
                                                    {inputs.deal_end_date !== '' && (
                                                        <div className='gap-2'>Expired on: <h6 className='dd-left-date mb-0'>{moment(inputs.deal_end_date).format("D MMMM, YYYY")}</h6></div>
                                                    )}
                                                </Col>
                                            </Row>
                                            {inputs.admin_approve ? (
                                            <div className="md-switch-box mt-2">
                                                <div>
                                                    <h6 className="mb-0">Active</h6>
                                                    <Form.Check
                                                        type="switch"
                                                        id="active-switch"
                                                        checked={isActive}
                                                        onChange={(e) => handleStatus(e)}
                                                    />
                                                </div>
                                            </div>
                                            ):null}

                                            <h5 className="fw-600 mt-3">Deal Description</h5>
                                            <p><div
                                                      dangerouslySetInnerHTML={{
                                                        __html: inputs.description.replace(/\n/g, "<br/>"),
                                                      }}
                                                    ></div></p>

                                            <div className="d-flex gap-2">
                                                <Button className="deal-delete-btn w-50" onClick={() => delete_modal_deal()}>
                                                    DELETE DEAL
                                                    <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/del-new.png'} className="img-fluid" alt="del" />
                                                </Button>


                                                {(() => {
                                                    if (inputs.deal_master_type === 'free') {
                                                        return (
                                                            <Link to={`/business/edit-freeitem-sale/${inputs.deal_id}`} className="deal-edit-btn w-50 text-decoration-none">
                                                                EDIT DEAL
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-new.png'} className="img-fluid" alt="edit" />
                                                            </Link>
                                                        )
                                                    } else if (inputs.deal_master_type === 'specific') {
                                                        return (
                                                            <Link to={`/business/edit-product-sale/${inputs.deal_id}`} className="deal-edit-btn w-50 text-decoration-none">
                                                                EDIT DEAL
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-new.png'} className="img-fluid" alt="edit" />
                                                            </Link>
                                                        )
                                                    } else if (inputs.deal_master_type === 'general') {
                                                        return (
                                                            <Link to={`/business/edit-store-sale/${inputs.deal_id}`} className="deal-edit-btn w-50 text-decoration-none">
                                                                EDIT DEAL
                                                                <Image src={process.env.REACT_APP_BASE_URL + 'assets/images/edit-new.png'} className="img-fluid" alt="edit" />
                                                            </Link>
                                                        )
                                                    }
                                                })()}

                                                
                                            </div>

                                        </div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            <Footer />
            <Modal
                size="md"
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
                className='deal-modal'
                centered
            >
                <Modal.Header closeButton={false}>
                </Modal.Header>
                <Modal.Body>
                    <h5 className="mb-5">Do you want to permanently delete this deal?</h5>
                    <div className="d-flex justify-content-end gap-3 mt-4">
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={delete_deal}>
                            Delete
                        </Button>
                    </div>
                </Modal.Body>
            </Modal>
            {loading && (
                <div className="loadingClass">
                    <img src={loader} alt="loader" />
                </div>
            )}
        </>
    )
}

export default BusinessDealDetail;


